
/*
* @license
* PIPELINE Theme (c) Groupthought Themes
*
* This file is included for advanced development by
* Shopify Agencies. Modified versions of the theme
* code are not supported by Shopify or Groupthought.
*
* Add any minor JS changes in assets/custom.js, this
* will make it easier to update the theme in the future.
*
*/
                  
import Alpine from 'alpinejs';

(function() {
    const env = {"NODE_ENV":"production"};
    try {
        if (process) {
            process.env = Object.assign({}, process.env);
            Object.assign(process.env, env);
            return;
        }
    } catch (e) {} // avoid ReferenceError: process is not defined
    globalThis.process = { env:env };
})();

var ThemeEditorEvent;
(function (ThemeEditorEvent) {
    ThemeEditorEvent["INSPECTOR_ACTIVATED"] = "shopify:inspector:activate";
    ThemeEditorEvent["INSPECTOR_DEACTIVATED"] = "shopify:inspector:deactivate";
    ThemeEditorEvent["SECTION_LOAD"] = "shopify:section:load";
    ThemeEditorEvent["SECTION_UNLOAD"] = "shopify:section:unload";
    ThemeEditorEvent["SECTION_SELECT"] = "shopify:section:select";
    ThemeEditorEvent["SECTION_DESELECT"] = "shopify:section:deselect";
    ThemeEditorEvent["SECTION_REORDER"] = "shopify:section:reorder";
    ThemeEditorEvent["BLOCK_SELECT"] = "shopify:block:select";
    ThemeEditorEvent["BLOCK_DESELECT"] = "shopify:block:deselect";
})(ThemeEditorEvent || (ThemeEditorEvent = {}));

var ThemeEvent;
(function (ThemeEvent) {
    ThemeEvent[ThemeEvent["theme:cart:add"] = 0] = "theme:cart:add";
    ThemeEvent[ThemeEvent["theme:cart:update"] = 1] = "theme:cart:update";
    ThemeEvent[ThemeEvent["theme:section:navigate"] = 2] = "theme:section:navigate";
    ThemeEvent[ThemeEvent["theme:section:load"] = 3] = "theme:section:load";
    ThemeEvent[ThemeEvent["theme:section:update"] = 4] = "theme:section:update";
})(ThemeEvent || (ThemeEvent = {}));

async function onThemeEvent(events) {
    // Wait for Alpine to be initialized if it has not been already
    if (!window.Alpine) {
        await new Promise((resolve) => window.addEventListener('alpine:initialized', resolve));
    }
    Object.entries(events).forEach(([event, callback]) => {
        window.addEventListener(event, callback);
    });
}
function dispatchThemeEvent(event, detail) {
    window.dispatchEvent(new CustomEvent(event, { detail }));
}

/**
 * Global theme event handler for the theme.
 */
onThemeEvent({
    /* Cart events */
    'theme:cart:add': (e) => {
        // If the cart action was triggered from the quickview drawer, open the cart drawer
        if (e.target?.matches('#product-quickview-drawer &') &&
            Alpine.store('drawer').isOpen) {
            dispatchThemeEvent('theme:cart-drawer:open', {});
            return;
        }
        // If any other drawer is already open, do nothing
        if (Alpine.store('drawer').isOpen) {
            return;
        }
        // Take different actions depending on cart action theme setting
        switch (window.theme.cart?.action) {
            case 'show_notification':
                dispatchThemeEvent('theme:cart-notification:open', e.detail);
                break;
            case 'show_drawer':
                dispatchThemeEvent('theme:cart-drawer:open', {});
                break;
            case 'navigate_page':
                if (!e.detail)
                    return;
                // Navigate to cart page
                window.location.assign(window.theme.routes.cart);
                break;
        }
    },
    /* Cart overlay events */
    'theme:cart-drawer:open': (e) => {
        Alpine.store('drawer').type = 'cart';
        Alpine.store('drawer').isOpen = true;
    },
    'theme:cart-drawer:close': (e) => {
        if (Alpine.store('drawer').type === 'cart') {
            Alpine.store('drawer').isOpen = false;
        }
    },
    /* Product pickup drawer events */
    'theme:product-pickup-drawer:open': (e) => {
        Alpine.store('drawer').type = 'pickup';
        Alpine.store('drawer').isOpen = true;
        Alpine.store('drawer').data = {
            url: e.detail.url,
        };
    },
    'theme:product-pickup-drawer:close': (e) => {
        if (Alpine.store('drawer').type === 'pickup') {
            Alpine.store('drawer').isOpen = false;
            Alpine.store('drawer').data = null;
        }
    },
    /* Quickview overlay events */
    'theme:product-quickview-drawer:open': (e) => {
        if (!e.detail?.url) {
            throw new Error(`theme:product-quickview-drawer:open event must have url`);
        }
        const wasCartDrawerOpen = Alpine.store('drawer').type === 'cart' && Alpine.store('drawer').isOpen;
        Alpine.store('drawer').type = 'quickview';
        Alpine.store('drawer').isOpen = true;
        Alpine.store('drawer').data = {
            url: e.detail.url,
            // Keep track of whether the quickview was opened from the cart drawer
            returnToCartDrawer: wasCartDrawerOpen,
        };
    },
    'theme:product-quickview-drawer:close': () => {
        if (Alpine.store('drawer').type === 'quickview') {
            // If the quickview was opened from the cart drawer, take user back to cart drawer instead of closing the quickview
            if (Alpine.store('drawer').data?.returnToCartDrawer) {
                Alpine.store('drawer').type = 'cart';
                Alpine.store('drawer').isOpen = true;
                Alpine.store('drawer').data = null;
                return;
            }
            Alpine.store('drawer').isOpen = false;
            Alpine.store('drawer').data = null;
        }
    },
    /* Header menu overlay events */
    'theme:menu-drawer:open': () => {
        Alpine.store('drawer').isOpen = true;
        Alpine.store('drawer').type = 'menu';
    },
    'theme:menu-drawer:close': () => {
        if (Alpine.store('drawer').type === 'menu') {
            Alpine.store('drawer').isOpen = false;
        }
    },
});
